import { Meta, Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { EnvService } from './env.service';
import { JournalService } from '../journal/journal.service';

const META_TAG_KEY = makeStateKey<any>('metaTags');

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  constructor(private meta: Meta, private title: Title, private transferState: TransferState,private EnvService:EnvService,private journalService:JournalService) {}

  public createMetadataforSEONew(data: any) {  
    const language = localStorage.getItem('language');
    let languageCode: string = JSON.stringify(language);
    languageCode = this.removeQuotes(languageCode);
    const pageHeading = data.temp_page_heading[languageCode];
    const pageContent = data.page_content[languageCode];
    const html = new DOMParser().parseFromString(pageContent, 'text/html');
    const contentTags = html.getElementsByTagName('a');
 
    Array.from(contentTags).forEach(element => {
        element.setAttribute('target', '_blank');
    });

    const serializer = new XMLSerializer();
    let serializedContent = serializer.serializeToString(html);

    // Clean up the content
     serializedContent = serializedContent
        .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
        .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
        .replace(/(\r\n|\n|\r)/g, ' '); // Replace newlines with a single space

     const content = serializedContent
        .replace(/<[^>]*>/g, '') // Remove HTML tags
        .split(/[.!?]/) // Split into sentences
        .filter(sentence => sentence.trim() !== '') // Remove empty sentences
        .slice(0, 5) // Take the first five sentences
        .join('. '); // Join with a period and space

    // Update meta tags
    this.meta.updateTag({ property: 'og:url', content: `${this.EnvService.siteUrl}content/${data.page_identifier}` });
    this.meta.updateTag({ property: 'og:type', content: 'content' });
    this.meta.updateTag({ property: 'og:title', content: `${pageHeading} | ${this.journalService.journal_displayname}` });
    this.meta.updateTag({ property: 'og:description', content });

    // Optionally update the title
    this.title.setTitle(`${pageHeading} | ${this.journalService.journal_displayname}`);

    // Transfer meta tag state to make it available on client side
    this.transferState.set(META_TAG_KEY, {
        url: `${this.EnvService.siteUrl}content/${data.page_identifier}`,
        type: 'content',
        title: `${pageHeading} | ${this.journalService.journal_displayname}`,
        description: content
    });
}


  private removeQuotes(value: string): string {
    return value.replace(/^"(.*)"$/, '$1');
  }
}
